import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    borderBottom: "1px solid #d5d2d5",
    backgroundColor: "#f6f6f7"
  },

  titleText: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#4b1c46"
  },

  dialogContent: {
    // Flush on every side - the table's own header sits directly under the
    // dialog title, and a gap above it reads as a glitch.
    padding: 0
  },

  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px"
  },

  tableContainer: {
    maxHeight: "60vh"
  },

  headCell: {
    backgroundColor: "#f6f6f7",
    color: "#4b1c46",
    fontSize: "12px",
    fontWeight: 500,
    letterSpacing: "0.4px",
    whiteSpace: "nowrap",
    cursor: "pointer",
    userSelect: "none"
  },

  headCellContent: {
    display: "flex",
    alignItems: "center",
    gap: "4px"
  },

  filterIcon: {
    fontSize: "17px",
    color: "#aaa2aa"
  },

  filterIconActive: {
    color: "#1976d2"
  },

  cell: {
    fontSize: "13px",
    color: "#333",
    verticalAlign: "top"
  },

  allSites: {
    fontStyle: "italic",
    color: "#736973"
  },

  emailList: {
    display: "flex",
    flexDirection: "column",
    gap: "2px"
  },

  email: {
    fontSize: "13px",
    wordBreak: "break-all"
  },

  incrementalTag: {
    display: "inline-block",
    marginTop: "5px",
    padding: "1px 8px",
    borderRadius: "10px",
    fontSize: "11px",
    color: "#4b1c46",
    backgroundColor: "rgba(75, 28, 70, 0.08)"
  },

  lastNotified: {
    fontSize: "11px",
    color: "#8f8a8f",
    marginTop: "2px"
  },

  deleteIcon: {
    width: "18px",
    height: "18px"
  },

  emptyCell: {
    borderBottom: "none",
    padding: "48px 16px"
  },

  emptyText: {
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "italic",
    color: "#8f8a8f"
  }
}));

export default useStyles;
